import { render, staticRenderFns } from "./MatchNapCPopup.vue?vue&type=template&id=25a86dc6&scoped=true"
import script from "./MatchNapCPopup.vue?vue&type=script&lang=js"
export * from "./MatchNapCPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a86dc6",
  null
  
)

export default component.exports